
import { useEffect } from 'react';
import { Card, CardContent } from "@/components/ui/card";

const StarRating = () => (
  <div className="flex text-amber-400 mb-2">
    <span className="text-xl">⭐⭐⭐⭐⭐</span>
  </div>
);

const Testimonials = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.reveal-on-scroll');
    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  const testimonials = [
    {
      name: "Avis Google",
      text: "Meredith est une personne exceptionnelle, à l'écoute, douce et bienveillante. Je la recommande les yeux fermés.",
    },
    {
      name: "Avis Google",
      text: "Un moment d'écoute, de compréhension, de bienveillance et de réponses, Meredith est vraiment incroyable.",
    },
    {
      name: "Avis Google",
      text: "Cela fait plusieurs années que Meredith m'accompagne. Grâce à sa bienveillance, sa patience et sa douceur, elle m'a aidé à transformer ma vie. Elle offre un accompagnement empreint de lumière, merci beaucoup !",
    },
    {
      name: "Avis Google",
      text: "Meredith est une thérapeute très à l'écoute, bienveillante et douce. Je la recommande vivement.",
    },
  ];

  return (
    <section id="testimonials" className="section-padding bg-accent/10">
      <div className="max-w-7xl mx-auto">
        <h2 className="section-title text-center mb-8 reveal-on-scroll">Ils en parlent le mieux</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="card-soft reveal-on-scroll" style={{ animationDelay: `${index * 100}ms` }}>
              <CardContent className="pt-6">
                <div className="flex flex-col h-full">
                  <div className="mb-2">
                    <p className="font-bold text-primary text-lg">{testimonial.name}</p>
                    <StarRating />
                  </div>
                  <div className="text-foreground/80 italic flex-grow">
                    {testimonial.text.split('\n').map((paragraph, i) => (
                      <p key={i} className="mb-2">{paragraph}</p>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
